import { BLOG_GUIDE_CONTENT_DATES } from './blogGuideContentDates.generated';

/** @param {string} isoDate YYYY-MM-DD */
export function formatBlogDateDisplay(isoDate) {
  if (!isoDate || typeof isoDate !== 'string') return '';
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

/**
 * Merges git-derived published/updated dates onto a blog registry entry when available.
 * @param {import('./blogRegistry').BlogPostMeta} post
 */
export function applyGuideContentDates(post) {
  const dates = BLOG_GUIDE_CONTENT_DATES[post.slug];
  if (!dates) return post;
  return {
    ...post,
    publishedAt: dates.publishedAt,
    updatedAt: dates.updatedAt,
    publishedLabel: formatBlogDateDisplay(dates.publishedAt),
    updatedLabel: formatBlogDateDisplay(dates.updatedAt),
  };
}
